import { render, staticRenderFns } from "./iconSquareUp.vue?vue&type=template&id=68ababd4&scoped=true"
import script from "./iconSquareUp.vue?vue&type=script&lang=js"
export * from "./iconSquareUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ababd4",
  null
  
)

export default component.exports